import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";

import Login      from "./pages/Login";
import Home       from "./pages/Home";
import Attendance from "./pages/Attendance";
import Expenses   from "./pages/Expenses";
import Drawings   from "./pages/Drawings";
import { Sites, SiteDetail } from "./pages/Sites";

function AppShell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-center"
          // Clear the notch / status bar so toasts aren't clipped on iPhone.
          containerStyle={{ top: "calc(env(safe-area-inset-top, 0px) + 12px)" }}
          toastOptions={{
            duration: 3500,
            style: {
              background: "#ffffff",
              color: "#0f172a",
              border: "1px solid #e2e8f0",
              borderRadius: "14px",
              fontSize: "14px",
              fontWeight: 500,
              padding: "12px 16px",
              maxWidth: "92vw",
              boxShadow: "0 8px 24px -8px rgba(15,23,42,.24)",
            },
            success: { iconTheme: { primary: "#15803d", secondary: "#ffffff" } },
            error:   { duration: 5000, iconTheme: { primary: "#dc2626", secondary: "#ffffff" } },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/"           element={<AppShell><Home /></AppShell>} />
          <Route path="/attendance" element={<AppShell><Attendance /></AppShell>} />

          {/* Expenses — optional :type param for quick-add */}
          <Route path="/expenses"          element={<AppShell><Expenses /></AppShell>} />
          <Route path="/expenses/new"      element={<AppShell><Expenses /></AppShell>} />
          <Route path="/expenses/new/:type" element={<AppShell><Expenses /></AppShell>} />

          <Route path="/drawings"    element={<AppShell><Drawings /></AppShell>} />
          <Route path="/sites"       element={<AppShell><Sites /></AppShell>} />
          <Route path="/sites/:id"   element={<AppShell><SiteDetail /></AppShell>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
